"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFieldsInExpression = exports.stripFilterFromExpression = void 0;
var spel2js_1 = require("spel2js");
var getFieldsInAst_1 = __importDefault(require("../../../spel/getFieldsInAst"));
var stripFilterFromExpression = function (exp) {
    var beforeFilter = /(^.*) \| [^"'’“”0-9]+$/gm;
    var match = beforeFilter.exec(exp);
    if (match) {
        return match[1];
    }
    return exp;
};
exports.stripFilterFromExpression = stripFilterFromExpression;
var getFieldsInExpression = function (compile) {
    if (compile === void 0) { compile = spel2js_1.SpelExpressionEvaluator.compile; }
    return function (_expression) {
        var expression = (0, exports.stripFilterFromExpression)(_expression);
        var compiledExpression = spel2js_1.SpelExpressionEvaluator.compile(expression)
            ._compiledExpression;
        var fields = (0, getFieldsInAst_1.default)(expression)(compiledExpression);
        return fields
            .map(function (f) {
            var s = f.split('._ALL_').join('.');
            return s.endsWith('.') ? s.slice(0, -1) : s;
        })
            .map(function (f) { return (f.endsWith('.length') ? f.slice(0, '.length'.length * -1) : f); });
    };
};
exports.getFieldsInExpression = getFieldsInExpression;
//# sourceMappingURL=index.js.map